import { useQuery } from "react-query";
import { getCardReaderByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetCardReaderByRecordNumber = (recNumber) => {
  return useQuery(
    ["GetCardReaderByRecordNumber", recNumber],
    () => getCardReaderByRecordNumber(recNumber),
    { refetchOnWindowFocus: false }
  );
};
